module.exports = __webpack_public_path__ + "img/19_25.fee63a5c.png";